import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import PageLayout from '../../components/page-layout';
import {
    useGetHelpCategoriesQuery,
    useHelpCategoriesLoaded,
} from '../../api/help-categories';
import Search from './components/search';
import MainText from './components/mainText';

const MainPage = () => {

    const { t } = useTranslation()
    const categoriesLoaded = useHelpCategoriesLoaded()

    useGetHelpCategoriesQuery(undefined, {
        skip: categoriesLoaded,
    })

    return (
        <PageLayout>
            <Typography variant='h4' sx={{
                fontWeight: 700,
                letterSpacing: 0,
                fontSize: '32px',
                lineHeight: '40px',
            }}>
                {t('text__welcomeToTheHelpCenter')}
            </Typography>
            <Search/>
            <MainText/>
        </PageLayout>
    )
};

export default MainPage;
